import {resources} from "../../../../../../../core/models/resource/resources";
import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const noteChangePriceModalResourceType = resources['notes-change-price'];

export const noteChangePriceProduct: ColumnPropertyLazySelect = {
  recourseName: 'NoteChangePriceDto',
  providerType: 'NOTE_CHANGE_PRICE_PRODUCT'
}
